import { createAsyncThunk } from "@reduxjs/toolkit";
import { Client } from "@helpers/helpers";
import { API_METHOD } from "@constants/constants";
import { url } from "@constants/url-constants";

export const getRoleList = createAsyncThunk(
  "role/list",
  async ({ pageCount, limit, search }) => {
    const response = await Client(
      API_METHOD.GET,
      url.roles +
        `?page=${pageCount}&limit=${limit}&deleted_at=1&q=${
          !search ? "" : search
        }`
    );
  
    return response.data;
  }
);

export const addRole = createAsyncThunk(
  "role/add",
  async (data, { rejectWithValue }) => {
    try {
      const response = await Client(API_METHOD.POST, url.roles, data);
      return response.data;
    } catch (error) {
      if (error) {
        return rejectWithValue(error);
      } else {
        return rejectWithValue("Something went wrong");
      }
    }
  }
);

//fetch

export const editRole = createAsyncThunk(
  "role/edit",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await Client(
        API_METHOD.PUT,
        url.roles + `/${id}`,
        data
      );
      return response.data;
    } catch (error) {
      if (error) {
        return rejectWithValue(error);
      } else {
        return rejectWithValue("Something went wrong");
      }
    }
  }
);

export const getPermisionList = createAsyncThunk(
  "permissions/get",
  async (data,{ rejectWithValue }) => {
    try {
      const response = await Client(
        API_METHOD.GET,
        url.permissions,
        null
      );
      return response.data;
    } catch (error) {
      if (error) {
        return rejectWithValue(error);
      } else {
        return rejectWithValue("Something went wrong");
      }
    }
  }
);
export const getRoleCount = async () =>{
  const response = await Client(API_METHOD.GET, url.roles)
  return response.data?.data?.item?.total_count;
}


export const getRole = createAsyncThunk("role/one", async (id) => {
  const response = await Client(API_METHOD.GET, url.roles + `/${id}`);
  return response.data;
});

